<template>
  <modal
    :center="true"
    :dialogVisible="modals.showEdit"
    :show-close="false"
    class="modal-edit-study-set"
    width="1280px"
  >
    <template v-slot:body>
      <edit-study-set
        ref="editStudySet"
        :study-set-id="studySetId"
        :showBreadcrumb="false"
      />
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/common/Modal";
import EditStudySet from "@/components/studysets/EditStudySet";

export default {
  components: {
    Modal,
    EditStudySet,
  },
  data() {
    return {
      modals: {
        showEdit: false,
      },
      deleteStudySetId: -1,
      studySetId: null,
    };
  },
  methods: {
    init(studySetId) {
      this.studySetId = studySetId;
      this.modals.showEdit = true;
    },
    close() {
      this.modals.showEdit = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-edit-study-set {
  ::v-deep {
    .el-dialog__header {
      display: none;
    }
    .edit-study-set {
      padding-bottom: 0 !important;
    }
  }
}
</style>
